import { SITE_NAME } from 'constants/site';
import { NAV_LINKS, FOOTER_LINKS, SOCIAL_LINKS } from 'constants/links';
import Link from 'components/Link';
import React, { Fragment } from 'react';
import { SITE_LOGO } from 'constants/logos';
import styles from 'styles/SiteFooter';
import ActionIcon from '../ActionIcon';
import LogoLink from '../LogoLink';

const renderLinks = (navigation, heading) => {
  const headingLink = [
    <li key={heading}>
      <p className="SiteFooter--navHeading">{heading}</p>
    </li>
  ];
  const navLinks = navigation.map(({ as, label, href }) => (
    <li className="SiteFooter__nav-item" key={href}>
      <Link href={href} as={as}>
        <a className="SiteFooter__nav-link">{label}</a>
      </Link>
    </li>
  ));

  return headingLink.concat(navLinks);
};

const renderSocialLinks = links =>
  links.map(({ label, href }) => (
    <div className="SiteFooter__action" key={href}>
      <ActionIcon
        target={label !== 'email' ? '_blank' : undefined}
        url={href}
        type={label}
        variant="knockout"
      />
    </div>
  ));

function SiteFooter() {
  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <footer className="SiteFooter">
      <div className="SiteFooter__block">
        <div className="SiteFooter__logo">
          <LogoLink
            className="SiteFooter__logo-link"
            logo={SITE_LOGO}
            href="/"
            placement="Site footer"
          />
        </div>
        <div className="SiteFooter__follow">
          {SOCIAL_LINKS.length > 0 && (
            <Fragment>
              <span>Follow us</span>
              <div className="SiteFooter__actions">
                {renderSocialLinks(SOCIAL_LINKS)}
              </div>
            </Fragment>
          )}
          <div className="SiteFooter__network">
            {SITE_NAME} is a part of the AT Media family. AT Media is{' '}
            <a href="https://www.apartmenttherapy.com">Apartment Therapy</a>,{' '}
            <a href="https://www.thekitchn.com">Kitchn</a>, and{' '}
            <a href="https://www.cubbyathome.com">Cubby</a>.
          </div>
        </div>
        <div className="SiteFooter__reader-submission">
          Got a tip, kitchen tour, or other story our readers should see?{' '}
          <Link as="/about/submissions" href="/page?path=/about/submissions">
            <a className="SiteFooter__reader-submission-button">
              Tell us about it!
            </a>
          </Link>
        </div>
        <nav className="SiteFooter__nav SiteFooter__nav--categories">
          {NAV_LINKS.length > 0 && (
            <ul className="SiteFooter__nav-items">
              {renderLinks(NAV_LINKS, 'Read')}
            </ul>
          )}
        </nav>
        <nav className="SiteFooter__nav SiteFooter__nav--company">
          {FOOTER_LINKS.length > 0 && (
            <ul className="SiteFooter__nav-items">
              {renderLinks(FOOTER_LINKS, 'Company')}
            </ul>
          )}
        </nav>
        <div className="SiteFooter__legal">
          {`${SITE_NAME} is © 1994-${currentYear}`} Apartment Therapy, LLC
        </div>
      </div>
      <style jsx>{styles}</style>
    </footer>
  );
}

export default SiteFooter;
